import { defineRecipe } from '@chakra-ui/react';

export const inputRecipe = defineRecipe({
    base: {
        borderRadius: 'lg',
        focusRingWidth: '2px',
        _focus: {},
        _focusVisible: {
            outlineOffset: '2px',
        },
        '--error-color': '{colors.red.solid}',
    },
    variants: {
        size: {
            md: {
                fontSize: 'md',
                h: '2.875rem',
            },
        },
    },
});
